import React from "react";
import {
  ClientMenu,
  SecondaryNavCustomer,
} from "../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import UsersTableCustomer from "../../../components/AdminComponents/UserTableCustomer";
import DetailsContainer from "../../../components/DetailsContainer";

const CustomerRelationships = () => {
  const { id } = useParams();
  const namingData = useSelector((state) => state.orgdeatil);
  const details = [
    {
      label: "Parent Client ID",
      value: namingData?.customer_client_id,
    },
    {
      label: "Parent Client Name",
      value: namingData?.customer_client_name,
    },
    { label: "Customer ID", value: namingData.id },
    { label: "Customer Name", value: namingData.name },
  ];

  return (
    <div>
      <Sidebar props={ClientMenu}>
        <SecondaryNav menuItems={SecondaryNavCustomer} id={parseInt(id)} />
        <DetailsContainer details={details} />
        <UsersTableCustomer />
      </Sidebar>
    </div>
  );
};

export default CustomerRelationships;
